import { render } from "./NewTDACartCommonDetails.vue?vue&type=template&id=60d537da"
import script from "./NewTDACartCommonDetails.vue?vue&type=script&lang=js"
export * from "./NewTDACartCommonDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__